import Dinero from "dinero.js";

export const createPrice = (amount: number) => Dinero({ amount, currency: "EUR" });
